module.exports = __webpack_public_path__ + "img/111.45377c3c.jpg";